// extracted by mini-css-extract-plugin
module.exports = {"banner":"CategoryBanner_banner__SXPAy","banner__header":"CategoryBanner_banner__header__Hh1dR","banner__image":"CategoryBanner_banner__image__GLIRn"};